import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { toast } from 'react-toastify';
import { getHelpCenterSettingsApi } from "../services/apiService";
import { ADMIN_DASHBOARD_URL, IMAGE_URL } from "../app_url";
import './AppDownloadValidation.scss';

const AppDownloadValidation = () => {
    const [code, setCode] = useState('');
    const [isValidated, setIsValidated] = useState(false);
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await getHelpCenterSettingsApi();
            if (response.data.res) {
                setSettings(response.data.settings);
            }
        } catch (error) {
            console.error("Error fetching help center settings:", error);
        } finally {
            setLoading(false);
        }
    };
    
    const handleValidate = (e) => {
        e.preventDefault();
        
        // Extract expected code from URL
        const params = new URLSearchParams(location.search);
        const v = params.get('v');
        let expectedCode = "";
        
        if (v) {
            try {
                // Handle base64 padding if necessary (though our generation removes it)
                const paddedV = v.padEnd(v.length + (4 - v.length % 4) % 4, '=');
                expectedCode = atob(paddedV);
            } catch (err) {
                console.error("Error decoding verification token", err);
            }
        }

        if (expectedCode) {
            if (code === expectedCode) {
                setIsValidated(true);
                toast.success("Code validé !");
            } else {
                toast.error("Code secret incorrect. Veuillez vérifier le code affiché sur l'écran.");
            }
        } else {
            // Fallback for direct access without token
            toast.error("Lien de téléchargement invalide. Veuillez scanner à nouveau le QR code.");
        }
    };

    const handleDownload = () => {
        if (settings?.app_scan_apk) {
            const baseUrl = ADMIN_DASHBOARD_URL || IMAGE_URL;
            const cleanPath = settings.app_scan_apk.startsWith('/') ? settings.app_scan_apk.substring(1) : settings.app_scan_apk;
            const downloadUrl = `${baseUrl}${baseUrl.endsWith('/') ? '' : '/'}${cleanPath}`;
            window.location.href = downloadUrl;
        } else {
            // Fallback to Google Play link if APK not uploaded
            window.location.href = settings?.android_link || "https://play.google.com/store/apps/details?id=com.doctolik.scan";
        }
    };

    if (loading) {
        return <div className="validation-container"><p>Chargement...</p></div>;
    }

    return (
        <div className="validation-container">
            <div className="validation-card">
                <h2>Téléchargement App Scan</h2>
                {!isValidated ? (
                    <form onSubmit={handleValidate}>
                        <p>Veuillez entrer le code secret affiché sur votre écran d'ordinateur pour continuer.</p>
                        <div className="input-group">
                            <input 
                                type="text" 
                                maxLength="4" 
                                value={code}
                                onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
                                placeholder="----"
                                className="code-input"
                            />
                        </div>
                        <button type="submit" className="validate-btn">Valider le code</button>
                    </form>
                ) : (
                    <div className="success-message">
                        <div className="success-icon">✓</div>
                        <p>Code validé avec succès ! Cliquez sur le bouton ci-dessous pour télécharger l'application.</p>
                        <button onClick={handleDownload} className="download-btn">
                            Télécharger l'application
                        </button>
                        <p className="retry-text">
                            Si le téléchargement ne commence pas, <a href="#" onClick={(e) => { e.preventDefault(); handleDownload(); }}>cliquez ici</a>.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AppDownloadValidation;
